import React from 'react';
import H3Text from '@Uilib/h3Text';
import ViewCustomFields from '@Components/Common/CustomField/ViewCustomFields';

const ViewStDetails = ({ selectedSt, toISTDate }) => {
  return (
    <React.Fragment>
      <div className="document-header" style={{ paddingTop: '15px' }}>
        <div className="ant-row">
          <div className="ant-col-md-12">
            <div className="document-header__field">
              <H3Text text="Transfer Date" className="document-header__field-name" />
              <H3Text
                text={
                  selectedSt?.stock_transfer_date
                    ? toISTDate(selectedSt.stock_transfer_date).format('DD/MM/YYYY')
                    : '-'
                }
                className="document-header__field-value"
              />
            </div>
          </div>

          {selectedSt?.created_by_info && (
            <div className="ant-col-md-12">
              <div className="document-header__field">
                <H3Text text="Created By" className="document-header__field-name" />
                <H3Text
                  text={selectedSt.created_by_info.first_name}
                  className="document-header__field-value"
                />
              </div>
            </div>
          )}

          {selectedSt?.created_at && (
            <div className="ant-col-md-12">
              <div className="document-header__field">
                <H3Text text="Created At" className="document-header__field-name" />
                <H3Text
                  text={toISTDate(selectedSt.created_at).format('DD/MM/YYYY')}
                  className="document-header__field-value"
                />
              </div>
            </div>
          )}

          {selectedSt?.short_close_reason && (
            <div className="ant-col-md-12">
              <div className="document-header__field">
                <H3Text text="Short Close Reason" className="document-header__field-name" />
                <H3Text
                  text={selectedSt.short_close_reason}
                  className="document-header__field-value"
                />
              </div>
            </div>
          )}

          {selectedSt?.reason_of_cancellation && selectedSt.status === 'VOID' && (
            <div className="ant-col-md-12">
              <div className="document-header__field">
                <H3Text text="Cancelling Reason" className="document-header__field-name" />
                <H3Text
                  text={selectedSt.reason_of_cancellation}
                  className="document-header__field-value"
                />
              </div>
            </div>
          )}

          {selectedSt?.custom_fields?.length > 0 && (
            <ViewCustomFields
              customFields={selectedSt.custom_fields.filter((cf) => cf.is_active)}
              wrapperClass="document-header__field"
              labelClass="document-header__field-name"
              valueClass="document-header__field-value"
              isHorizontal
            />
          )}
        </div>
      </div>

      <div className="document-address-list">
        <div className="ant-row">
          <div className="ant-col-md-12 ant-col-xs-24">
            <div className="document-address__left">
              <H3Text text="Source" className="document-address__title" />
              <H3Text
                text={selectedSt?.source_department_info?.tenant_name}
                className="document-address__details"
              />
              <H3Text
                text={`Department - ${selectedSt?.source_department_info?.department_name}`}
                className="document-address__details"
              />
              {selectedSt?.source_department_info?.tenant_billing_address_info?.address1 && (
                <H3Text
                  text={selectedSt.source_department_info.tenant_billing_address_info.address1}
                  className="document-address__details"
                />
              )}
              {selectedSt?.source_department_info?.tenant_billing_address_info?.address1 && (
                <H3Text
                  text={`${selectedSt.source_department_info.tenant_billing_address_info.city}, ${selectedSt.source_department_info.tenant_billing_address_info.state} ${selectedSt.source_department_info.tenant_billing_address_info.postal_code}`}
                  className="document-address__details"
                />
              )}
            </div>
          </div>

          <div className="ant-col-md-12 ant-col-xs-24">
            <div className="document-address__right">
              <H3Text text="Destination" className="document-address__title" />
              <H3Text
                text={selectedSt?.destination_department_info?.tenant_name}
                className="document-address__details"
              />
              <H3Text
                text={`Department - ${selectedSt?.destination_department_info?.department_name}`}
                className="document-address__details"
              />
              {selectedSt?.destination_department_info?.tenant_billing_address_info?.address1 && (
                <H3Text
                  text={selectedSt.destination_department_info.tenant_billing_address_info.address1}
                  className="document-address__details"
                />
              )}
              {selectedSt?.destination_department_info?.tenant_billing_address_info?.city && (
                <H3Text
                  text={`${selectedSt.destination_department_info.tenant_billing_address_info.city}, ${selectedSt.destination_department_info.tenant_billing_address_info.state} ${selectedSt.destination_department_info.tenant_billing_address_info.postal_code}`}
                  className="document-address__details"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewStDetails;
